<ng-container [formGroup]="searchForm" class="w-100">
    @if (enableBatchInput) {
        <fieldset [disabled]="disableInput" class="!border-0 p-0">
            @if (disableInput) {
                <mat-hint class="text-warn">
                    {{ 'info_disable_public_registry_search' | translate }}
                </mat-hint>
            }
            <mat-tab-group
                class="hopar-tab-group"
                [animationDuration]="'0'"
                [(selectedIndex)]="selectedPanelIndex"
                (selectedTabChange)="tabChanged($event)"
            >
                <mat-tab label="{{ 'label_single_ssn' | translate }}" [disabled]="disableInput">
                    <mat-form-field class="w-100">
                        <mat-label
                            [ngClass]="{
                                'validation-error-color': hasError && searchInputControl.touched,
                            }"
                            >{{ label }}</mat-label
                        >
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                        <input #matSearcher matInput [formControl]="searchInputControl" [matAutocomplete]="matAutocomplete" />
                        @if (loading) {
                            <mat-progress-spinner matSuffix [diameter]="18" [mode]="'indeterminate'"></mat-progress-spinner>
                        }
                        @if (subtitle) {
                            <mat-hint class="ml-auto">{{ subtitle }}</mat-hint>
                        }
                        @if (selectedOption) {
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:check'" matSuffix></mat-icon>
                        }
                    </mat-form-field>
                </mat-tab>
                <mat-tab label="{{ 'label_multiple_ssns' | translate }}" [disabled]="disableInput">
                    <mat-form-field class="w-100">
                        <mat-label
                            [ngClass]="{
                                'validation-error-color': hasError && (isBatch ? batchControl.touched : searchInputControl.touched),
                            }"
                        >
                            @if (isBatch) {
                                {{ label }}
                            } @else {
                                {{ pluralLabel }}
                            }
                        </mat-label>
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user-group'" matPrefix></mat-icon>
                        <textarea
                            #batchPaster
                            matInput
                            formControlName="batch"
                            rows="8"
                            (paste)="onBatchPaste($event)"
                            placeholder="Líma skal kennitölulista hér:&#10;0123456789&#10;012345-6789"
                        ></textarea>
                        @if (loading) {
                            <mat-progress-spinner matSuffix [diameter]="18" [mode]="'indeterminate'"></mat-progress-spinner>
                        }
                        @if (subtitle) {
                            <mat-hint class="ml-auto">
                                Líma skal kennitölulista í reitinn að ofan, t.d. frá Excel. Hægt er að sjá frekari leiðbeiningar
                                <a
                                    href="https://lsr.atlassian.net/wiki/spaces/rekstrarkerfi/pages/edit-v2/1232699443?draftShareId=3900ed2b-3d09-4c7f-8e1d-39babdb3f3d0"
                                    target="_blank"
                                    >hér
                                </a>
                            </mat-hint>
                        }
                        @if (selectedOption) {
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:check'" matSuffix></mat-icon>
                        }
                    </mat-form-field>
                </mat-tab>
            </mat-tab-group>
        </fieldset>
    } @else {
        <mat-form-field class="w-100">
            <mat-label
                [ngClass]="{
                    'validation-error-color': hasError && searchInputControl.touched,
                }"
            >
                {{ label }}
            </mat-label>
            <mat-icon matPrefix svgIcon="heroicons_solid:user" class="icon-size-5"></mat-icon>
            <input #matSearcher matInput [formControl]="searchInputControl" [matAutocomplete]="matAutocomplete" />
            @if (loading) {
                <mat-progress-spinner matSuffix diameter="18" mode="indeterminate"></mat-progress-spinner>
            }
            @if (subtitle) {
                <mat-hint class="ml-auto">{{ subtitle }}</mat-hint>
            }
            @if (selectedOption) {
                <mat-icon matSuffix svgIcon="heroicons_solid:check" class="icon-size-5"></mat-icon>
            }
        </mat-form-field>
    }
    <mat-autocomplete
        #matAutocomplete="matAutocomplete"
        (optionSelected)="optionSelected($event.option.value)"
        [displayWith]="optionDisplayFn"
    >
        @for (option of options; track option) {
            <mat-option [value]="option">{{ formatPersonDetails(option.ssn, option.name) }}</mat-option>
        }
    </mat-autocomplete>
</ng-container>
